const $ = jQuery;

class MainHeader {
	constructor() {
		this.header = document.querySelector('.main-header');
		this.mainMenu = document.querySelector('.main-header__nav-wrapper > ul');
		this.megaMenuBtns = document.querySelectorAll('.mm-button');
		this.megaMenuDropdowns = document.querySelectorAll('.mm-dropdown');
		this.tabs = document.querySelectorAll('.mm-tab');
		this.adminBar = document.getElementById('wpadminbar');
		this.mobileMenuToggle = document.getElementById('mobile-menu-toggle');
		this.backBtn = document.querySelector('.mm-back-btn');
		this.dropdownOverviewLinks = document.querySelectorAll('.mm-dropdown__overview-link');
		this.topNavItems = document.querySelectorAll(
			'.main-nav-menu > li > a, .main-nav-menu > li > button, .mobile-menu-links a, .mobile-sites-menu__trigger, .mobile-menu-btns__login, .main-header__primary-cta--mobile'
		);

		this.dropdownBtns = document.querySelectorAll('[data-nav-dropdown-btn]');
		this.backTimeoutRunning = false;
		this.backTimeout = setTimeout(() => false, 0);
	}

	init() {
		this.setHeaderHeight();
		this.handleNavResize();

		document.body.addEventListener('click', this.handleBodyClick.bind(this));
		document.body.addEventListener('keyup', this.handleKeyUp.bind(this));

		this.megaMenuBtns.forEach((btn) => {
			btn.addEventListener('click', this.toggleMegaMenu.bind(this));
		});

		this.tabs.forEach((tab) => {
			tab.addEventListener('click', this.handleTabClick.bind(this));
			tab.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
			tab.addEventListener('focus', this.handleTabFocus.bind(this));
		});

		this.dropdownOverviewLinks.forEach((link) => {
			link.addEventListener('focus', this.handleTabFocus.bind(this));
		});

		this.topNavItems.forEach((item) => {
			item.addEventListener('focus', this.handleTopNavItemFocus.bind(this));
		});

		this.dropdownBtns.forEach((btn) => {
			btn.addEventListener('click', this.handleDropdownBtnClick.bind(this));
		});

		this.backBtn.addEventListener('click', this.handleBackBtnClick.bind(this));

		this.mobileMenuToggle.addEventListener('click', this.toggleMobileMenu.bind(this));
	}

	resize() {
		this.setHeaderHeight();
		this.handleNavResize();
	}

	focus(e) {
		this.handleFocus(e);
	}

	load() {
		this.setHeaderHeight();
	}

	handleBodyClick(e) {
		// If click outside of the mega menu, close it.
		if (
			document.body.classList.contains('mm-open') &&
			window.matchMedia('(min-width: 1200px)').matches
		) {
			if (!document.querySelector('.menu-item-object-mega_menu.active').contains(e.target)) {
				this.closeMegaMenu();
			}
		}

		if (document.querySelector('.nav-dropdown.active')) {
			if (!document.querySelector('.nav-dropdown.active').contains(e.target)) {
				this.closeDropdowns(false);
			}
		}
	}

	handleFocus(e) {
		// Set timeout to prevent click flickers.
		setTimeout(() => {
			if (
				document.body.classList.contains('mm-open') &&
				window.matchMedia('(min-width: 1200px)').matches
			) {
				if (
					!document.querySelector('.menu-item-object-mega_menu.active').contains(e.target)
				) {
					this.closeMegaMenu(false);
				}
			}

			if (document.querySelector('.nav-dropdown.active')) {
				if (!document.querySelector('.nav-dropdown.active').contains(e.target)) {
					this.closeDropdowns(false);
				}
			}
		}, 100);
	}

	handleKeyUp(e) {
		if (27 === e.keyCode) {
			this.closeMegaMenu();
			this.closeDropdowns();
		}

		if (37 === e.keyCode || e.keyCode === 38) {
			const currentTabParent = document.querySelector(
				'.menu-item.active .mm-dropdown__item.active'
			);
			if (null !== currentTabParent) {
				const targetTabParent = currentTabParent.previousElementSibling;
				if (null !== targetTabParent) {
					const targetTab = targetTabParent.querySelector('.mm-tab');
					targetTab.focus();
					this.toggleTab(targetTab);
				}
			}
		}

		if (39 === e.keyCode || e.keyCode === 40) {
			const currentTabParent = document.querySelector(
				'.menu-item.active .mm-dropdown__item.active'
			);
			if (null !== currentTabParent) {
				const targetTabParent = currentTabParent.nextElementSibling;
				if (null !== targetTabParent) {
					const targetTab = targetTabParent.querySelector('.mm-tab');
					targetTab.focus();
					this.toggleTab(targetTab);
				}
			}
		}
	}

	closeMegaMenu(focus = false) {
		const activeMegaMenu = document.querySelector('.menu-item-object-mega_menu.active');
		if (null !== activeMegaMenu) {
			if (window.matchMedia('(min-width: 1200px)').matches) {
				$(activeMegaMenu.querySelector('.mm-dropdown')).slideUp();
			} else {
				activeMegaMenu.querySelector('.mm-dropdown').style.display = 'none';
			}
			activeMegaMenu.classList.remove('active');
			activeMegaMenu.querySelector('.mm-button').setAttribute('aria-expanded', 'false');
			document.body.classList.remove('mm-open');
			this.disableBackBtn();

			if (focus) {
				activeMegaMenu.querySelector('.mm-button').focus();
			}
		}
	}

	setHeaderHeight() {
		const headerHeight = this.header.offsetHeight;
		let headerHeightFull = this.header.offsetHeight;

		if (null !== this.adminBar) {
			headerHeightFull += this.adminBar.offsetHeight;
		}

		document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
		document.documentElement.style.setProperty('--headerHeight', headerHeight + 'px');
		document.documentElement.style.setProperty('--headerHeightFull', headerHeightFull + 'px');
	}

	toggleMegaMenu(event) {
		const { currentTarget } = event;
		const listItem = currentTarget.parentNode;

		if (listItem.classList.contains('active')) {
			listItem.classList.remove('active');
			currentTarget.setAttribute('aria-expanded', 'false');
			document.body.classList.remove('mm-open');
			if (window.matchMedia('(min-width: 1200px)').matches) {
				$(listItem.querySelector('.mm-dropdown')).slideUp();
			} else {
				listItem.querySelector('.mm-dropdown').style.display = 'none';
			}
			this.disableBackBtn();
		} else {
			this.megaMenuBtns.forEach((button) => {
				button.parentNode.classList.remove('active');
				button.setAttribute('aria-expanded', 'false');
			});

			this.dropdownBtns.forEach((btn) => {
				btn.parentNode.classList.remove('active');
				btn.setAttribute('aria-expanded', 'false');
			});

			if (document.body.classList.contains('mm-open')) {
				this.megaMenuDropdowns.forEach((dropdown) => {
					dropdown.style.display = 'none';
				});
				listItem.querySelector('.mm-dropdown').style.display = 'block';
			} else if (window.matchMedia('(min-width: 1200px)').matches) {
				$(listItem.querySelector('.mm-dropdown')).slideDown();
			} else {
				listItem.querySelector('.mm-dropdown').style.display = 'block';
			}

			listItem.classList.add('active');
			currentTarget.setAttribute('aria-expanded', 'true');
			document.body.classList.add('mm-open');
			this.activateBackBtn(currentTarget);
		}
	}

	handleMouseEnter(event) {
		if (window.matchMedia('(min-width: 1200px)').matches) {
			this.toggleTab(event.currentTarget);
		}
	}

	handleTabClick(event) {
		if (document.body.classList.contains('mobile-menu-open')) {
			event.preventDefault();
			event.stopImmediatePropagation();
		}
		this.toggleTab(event.currentTarget);
	}

	toggleTab(currentTarget) {
		const listItem = currentTarget.parentNode;

		if (!listItem.classList.contains('active')) {
			currentTarget
				.closest('.mm-dropdown__menu')
				.querySelectorAll('.mm-tab')
				.forEach((tab) => {
					tab.parentNode.classList.remove('active');
					tab.setAttribute('aria-selected', 'false');
					tab.setAttribute('tabindex', '-1');
					tab.parentNode
						.querySelector('.mm-tab-content')
						.setAttribute('aria-hidden', 'true');
				});

			listItem.classList.add('active');
			currentTarget.setAttribute('aria-selected', 'true');
			currentTarget.setAttribute('tabindex', '0');
			currentTarget.parentNode
				.querySelector('.mm-tab-content')
				.setAttribute('aria-hidden', 'false');
		}

		if (
			document.body.classList.contains('mm-open') &&
			document.body.classList.contains('mobile-menu-open')
		) {
			document.body.classList.add('mm-tab-selected');
			this.activateBackBtn(currentTarget);
		}
	}

	toggleMobileMenu() {
		document.body.classList.toggle('mobile-menu-open');

		if (
			!document.body.classList.contains('mobile-menu-open') &&
			document.body.classList.contains('is-mobile-bp')
		) {
			this.megaMenuDropdowns.forEach((dropdown) => {
				dropdown.style.display = 'none';
			});

			setTimeout(() => {
				this.mainMenu.style.display = 'none';
				document.body.classList.remove('mm-open');
				document.body.classList.remove('mm-tab-selected');
				this.disableBackBtn();
			});
		} else if (
			document.body.classList.contains('mobile-menu-open') &&
			document.body.classList.contains('is-mobile-bp')
		) {
			this.mainMenu.style.display = 'flex';
		}
	}

	handleTabFocus() {
		if (document.body.classList.contains('mm-tab-selected')) {
			document.body.classList.remove('mm-tab-selected');
		}
	}

	handleTopNavItemFocus() {
		if (
			window.matchMedia('(max-width: 1199px)').matches &&
			document.body.classList.contains('mm-open')
		) {
			document.body.classList.remove('mm-open');
			this.disableBackBtn();
		}
	}

	handleBackBtnClick() {
		if (document.body.classList.contains('mm-tab-selected')) {
			document.body.classList.remove('mm-tab-selected');
			const activeDropdown = document.querySelector('.menu-item.active > .mm-button');
			this.activateBackBtn(activeDropdown);
		} else if (document.body.classList.contains('mm-open')) {
			document.body.classList.remove('mm-open');
			this.megaMenuDropdowns.forEach((dropdown) => {
				dropdown.style.display = 'none';
			});
			this.disableBackBtn();
		}
	}

	disableBackBtn() {
		this.megaMenuBtns.forEach((btn) => {
			btn.parentNode.classList.remove('active');
			btn.setAttribute('aria-expanded', 'false');
		});
		this.backBtn.classList.remove('active');
	}

	activateBackBtn(target) {
		const backText = target.getAttribute('data-back-title');
		if (null === backText) {
			return;
		}

		const backEl = document.createElement('span');
		backEl.classList.add('active');
		backEl.textContent = backText;

		const oldSpan = this.backBtn.querySelector('span');
		if (null !== oldSpan) {
			oldSpan.classList.remove('active');

			// If timer is running, cut the animation short and delete everything.
			if (this.backTimeoutRunning) {
				this.backBtn.querySelectorAll('span').forEach((span) => {
					span.remove();
				});
				clearTimeout(this.backTimeout);
				this.backTimeoutRunning = false;
			} else {
				this.backTimeoutRunning = true;
				this.backTimeout = setTimeout(() => {
					this.backTimeoutRunning = false;
					oldSpan.remove();
				}, 600);
			}
		}

		this.backBtn.classList.add('active');
		this.backBtn.appendChild(backEl);
	}

	handleNavResize() {
		if (
			window.matchMedia('(max-width: 1199px)').matches &&
			!document.body.classList.contains('is-mobile-bp')
		) {
			document.body.classList.add('is-mobile-bp');
			document.body.classList.remove('mm-open');
			document.body.classList.remove('mm-tab-selected');
			this.disableBackBtn();
			if (!document.body.classList.contains('mobile-menu-open')) {
				this.mainMenu.style.display = 'none';
			}

			this.megaMenuDropdowns.forEach((dropdown) => {
				if (!dropdown.classList.contains('nav-dropdown__dropdown')) {
					dropdown.style.display = 'none';
				}
			});
		} else if (
			window.matchMedia('(min-width: 1200px)').matches &&
			document.body.classList.contains('is-mobile-bp')
		) {
			document.body.classList.remove('mobile-menu-open');
			document.body.classList.remove('is-mobile-bp');
			document.body.classList.remove('mm-open');
			document.body.classList.remove('mm-tab-selected');
			this.mainMenu.style.display = 'flex';
			this.disableBackBtn();
		}
	}

	handleDropdownBtnClick(event) {
		const { currentTarget } = event;

		const mobileUrl = currentTarget.getAttribute('data-mobile-url');
		const ariaExpanded = currentTarget.getAttribute('aria-expanded');

		if (null !== mobileUrl && window.matchMedia('(max-width: 1199px)').matches) {
			window.location.href = mobileUrl;
		} else if (ariaExpanded === 'false') {
			this.dropdownBtns.forEach((btn) => {
				btn.parentNode.classList.remove('active');
				btn.setAttribute('aria-expanded', 'false');
			});

			this.disableBackBtn();

			currentTarget.parentNode.classList.add('active');
			currentTarget.setAttribute('aria-expanded', 'true');
		} else {
			currentTarget.parentNode.classList.remove('active');
			currentTarget.setAttribute('aria-expanded', 'false');
		}
	}

	closeDropdowns(focus = true) {
		const activeDropdown = document.querySelector('.nav-dropdown.active');
		if (null !== activeDropdown) {
			this.dropdownBtns.forEach((btn) => {
				btn.parentNode.classList.remove('active');
				btn.setAttribute('aria-expanded', 'false');
			});

			if (focus) {
				activeDropdown.querySelector('[data-nav-dropdown-btn]').focus();
			}
		}
	}
}

export default new MainHeader();
